(() => {
  'use strict';

  const observed = new WeakMap();
  const MOBILE_MAX = 749;
  const MOBILE_BANNER_HEIGHT_MULTIPLIER = 1.5;

  const visibleProducts = (grid) => Array.from(grid.querySelectorAll('[data-collection-product]')).filter((item) => !item.hidden);

  function positionBanners(grid) {
    const products = visibleProducts(grid);
    const banners = Array.from(grid.querySelectorAll('[data-collection-grid-banner]'));
    banners
      .sort((a, b) => Number(a.dataset.afterVisibleProducts || 0) - Number(b.dataset.afterVisibleProducts || 0))
      .forEach((banner) => {
        const after = Math.max(1, Number(banner.dataset.afterVisibleProducts || 0));
        const target = products[after - 1];
        if (!target) return;
        if (target.nextElementSibling !== banner) target.insertAdjacentElement('afterend', banner);
      });
  }

  function getReferenceMedia(grid) {
    for (const productCard of visibleProducts(grid)) {
      const media = productCard.querySelector('.card__media');
      if (media && media.getBoundingClientRect().height > 50) return media;
    }
    return null;
  }

  function applyHeight(grid) {
    const media = getReferenceMedia(grid);
    if (!media) return;
    const productMediaHeight = Math.round(media.getBoundingClientRect().height);
    if (!productMediaHeight || productMediaHeight < 50) return;
    const multiplier = window.innerWidth <= MOBILE_MAX ? MOBILE_BANNER_HEIGHT_MULTIPLIER : 1;
    const height = Math.round(productMediaHeight * multiplier);

    grid.querySelectorAll('[data-collection-grid-banner]').forEach((tile) => {
      const body = tile.querySelector('[data-collection-grid-banner-body]');
      const picture = body?.querySelector(':scope > picture');
      const image = picture?.querySelector('img');
      if (!picture || !image) return;
      picture.style.setProperty('height', `${height}px`, 'important');
      picture.style.setProperty('display', 'block');
      image.style.setProperty('height', `${height}px`, 'important');
      image.style.setProperty('width', '100%', 'important');
      image.style.setProperty('object-fit', 'cover');
      image.style.setProperty('display', 'block');
    });
  }

  function bindGrid(grid) {
    if (!grid) return;
    let pendingFrame = 0;
    const schedule = () => {
      cancelAnimationFrame(pendingFrame);
      pendingFrame = requestAnimationFrame(() => {
        positionBanners(grid);
        applyHeight(grid);
      });
    };

    schedule();
    if (observed.has(grid)) return;

    const resizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;
    const referenceMedia = getReferenceMedia(grid);
    if (resizeObserver && referenceMedia) resizeObserver.observe(referenceMedia);

    grid.querySelectorAll('[data-collection-product] img, [data-collection-grid-banner] img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', schedule, { once: true });
        img.addEventListener('error', schedule, { once: true });
      }
    });

    const visibilityObserver = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.type === 'attributes' && mutation.attributeName === 'hidden')) schedule();
    });
    visibilityObserver.observe(grid, { subtree: true, attributes: true, attributeFilter: ['hidden'] });

    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule, { passive: true });
    document.addEventListener('brilinton:collection-products-added', schedule);
    window.addEventListener('brilinton:urlchange', schedule);

    observed.set(grid, { resizeObserver, visibilityObserver, schedule });
  }

  function init(scope = document) {
    if (scope.matches?.('#product-grid')) bindGrid(scope);
    scope.querySelectorAll?.('#product-grid').forEach(bindGrid);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target || document));
  window.addEventListener('brilinton:layout-refresh', () => init(document));
})();
